BaseModel = require './base_model.coffee'

class global.Template extends BaseModel
  @ATTRIBUTES = {
    id: {}
    name: {}
    subject: { default: '' }
    body: {}
    signature: {}
    category_name: {}
    template_category_id: { default: null, type: Number }
    parent_id: {}
    recipients_statistics: {}
    kind: {}
    actions_count: {}
    cc: {}
    value: {} # generic attribute
  }

  @ASSOCIATIONS = {
    email_statistic: -> EmailStatistic
    user: -> User
  }

  connectedCount: ->
    @recipients_statistics?.by_qualification?.connected?.count

  contentLabel: ->
    switch @kind
      when "email" then "Conteúdo do email"
      when "phonecall" then "Conteúdo do roteiro de ligação"
      when "linkedin" then "Conteúdo do Inmail"
      when "social" then "Conteúdo da mensagem em rede social"
      else "Conteúdo"



// WEBPACK FOOTER //
// ./src/models/template.coffee